export const IconSearch = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6439 7.12976C12.6439 10.1751 10.1751 12.6439 7.12976 12.6439C4.08439 12.6439 1.61564 10.1751 1.61564 7.12976C1.61564 4.08439 4.08439 1.61564 7.12976 1.61564C10.1751 1.61564 12.6439 4.08439 12.6439 7.12976ZM11.4555 12.3504C10.2816 13.3241 8.77405 13.9094 7.12976 13.9094C3.38546 13.9094 0.350098 10.8741 0.350098 7.12976C0.350098 3.38546 3.38546 0.350098 7.12976 0.350098C10.8741 0.350098 13.9094 3.38546 13.9094 7.12976C13.9094 8.77407 13.3241 10.2817 12.3503 11.4555L16.1648 15.2699C16.4119 15.5171 16.4119 15.9177 16.1648 16.1648C15.9177 16.4119 15.517 16.4119 15.2699 16.1648L11.4555 12.3504Z"
        fill="#666666"
      />
    </svg>
  );
};
